import { useCallback, useEffect, useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { NetworkReferentialLayer, useNavigateToLinearLocation, useNetworksDispatchContext } from "@l2r-front/l2r-networks"

import { APP_SAFETY } from "../../../../common/constants/appSafety"
import { MODULE_RISK_ZONES } from "../../../../common/constants/modules"
import { RiskZonesLayer } from "../../containers/RiskZonesLayer/RiskZonesLayer"

import { RiskZoneValidator } from "../RiskZoneValidator"

export function RiskZonesMapLayersRouter() {

    const match = useMatch(`:slugId/${APP_SAFETY}/${MODULE_RISK_ZONES}/:road/*`)
    const road = decodeURIComponent(match?.params?.road)
    const isSegmentView = !!match

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { setSearchRoadCallback } = useMapDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedLinearLocations(feature)
            navigateToLinearLocation(location, ".", { saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked, setSelectedLinearLocations, navigateToLinearLocation, isSegmentView, road])

    useEffect(() => {
        setSearchRoadCallback((searchedRoad) => {
            processNavigation(null, { road: searchedRoad })
        })

        return () => setSearchRoadCallback(null)
    }, [
        setSearchRoadCallback,
        processNavigation])

    const layers = useMemo(() => {
        return (
            <>
                <NetworkReferentialLayer processNavigation={processNavigation} />
                <RiskZonesLayer />
                {isSegmentView && <ImageCollectionLayer road={road} />}
                {isSegmentView && <ImageSelectedLayer />}
            </>
        )
    }, [isSegmentView, processNavigation, road])

    const layersRoutes = useMemo(() => ([
        { path: "/", element: layers },
        { path: "/:road", element: layers },
        { path: "/:road/:riskZoneId", element: <RiskZoneValidator>{layers}</RiskZoneValidator> },
    ]), [layers])

    return useRoutes(layersRoutes)
}